import { HttpResponse, delay, http } from 'msw';

import { getCustomHandlerLoginStatus } from './utils';
import { MOCK_DELAY } from './utils/constants';

export const getCustomPlatformGetSyncRunMockHandler = () => {
  return http.get('*/teams/:team/syncs/:sync_name/runs/:sync_run_id', async () => {
    await delay(MOCK_DELAY);

    if (!getCustomHandlerLoginStatus()) {
      return new HttpResponse(null, { status: 401 });
    }

    const items = {
      completed_at: undefined,
      created_at: '2024-06-17T14:09:04.884907Z',
      errors: 1,
      id: 'f475f3ec-52b5-4fdd-bbef-b9bc0bc7e177',
      status: 'started',
      sync_name: 'gcp-gcs-2024-06-17',
      total_rows: 32,
      warnings: 0,
    };

    return HttpResponse.json(items, {
      status: 200,
    });
  });
};
